import { render, staticRenderFns } from "./ScoresDisplay.vue?vue&type=template&id=54088a48&scoped=true&"
import script from "./ScoresDisplay.vue?vue&type=script&lang=js&"
export * from "./ScoresDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ScoresDisplay.vue?vue&type=style&index=0&id=54088a48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54088a48",
  null
  
)

export default component.exports